import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PasswordControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-dynamic-password',
  templateUrl: './dynamic-password.component.html',
})
export class DynamicPasswordComponent {
  @Input() control: PasswordControl;
  @Input() formGroup: FormGroup;
  @Output() onOverrideValue = new EventEmitter();

  constructor() {}
  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
